import type { DatasetUploadJob } from "@/api/datasetUpload";

// 재개 후보 판정. "완료(complete) 전 업로드는 언제든 다시 진행할 수 있다" 는 요구에서 탐지 부분이다.
//
// Owns:
// - 어떤 서버 잡이 "이어서 업로드" 대상인지 정하는 정책: pending_upload 이고, 다른 브라우저의
//   살아 있는 lease 가 아니다. 승격 잡은 UPLOADED 로 시작하므로 pending_upload 가 될 수 없다.
//
// Does not own:
// - 실제 재개 실행(폴더 재선택 → probe diff → enqueue). UI 와 UploadEngine 이 소유한다.

// 다른 브라우저가 lease 를 살아 있는 상태로 점유 중인지 판정한다. 만료 판정은 서버 계산값을 신뢰한다.
export function isForeignLiveLease(job: DatasetUploadJob): boolean {
  return job.lease_active && !job.owned_by_me;
}

export function isResumableUpload(job: DatasetUploadJob): boolean {
  return job.status === "pending_upload";
}

// 재개 배너와 현황 페이지가 쓰는 후보 목록(최신 생성순). 다른 브라우저가 점유한 잡도 포함한다.
// 실행 가능 여부는 호출부가 isForeignLiveLease 로 판정한다.
export function listResumableUploads(jobs: readonly DatasetUploadJob[]): DatasetUploadJob[] {
  return jobs
    .filter(isResumableUpload)
    .sort((left, right) => (left.created_at > right.created_at ? -1 : 1));
}

// 지금 바로 이어받을 수 있는 최신 잡. 없으면 null.
export function findResumableUpload(jobs: readonly DatasetUploadJob[]): DatasetUploadJob | null {
  return listResumableUploads(jobs).find((job) => !isForeignLiveLease(job)) ?? null;
}
